<template>
  <div v-if="canOpen" class="btn-set mb-0 mt-3">
    <button class="btn btn-primary mx-2" @click="openDispute">Open Dispute</button>
  </div>
</template>
<script>
import api from '@/clients/api'
export default {
  props: {
    dispute: {
      type: Object,
      required: true
    }
  },
  computed: {
    canOpen() {
      return this.isStaff && (this.dispute.status != 'open')
    },
  },
  methods: {
    openDispute() {
      this.$parent.loading = true
      api.openDispute(this.dispute.id).then(response => {
        this.$parent.show = false
        this.$parent.loading = false
        this.$parent.$emit('reload')
      })
    },
  }
}
</script>
